import { HTMLAttributes } from 'react';

import styled from 'styled-components';

import { IconDrag } from '@components/icons/drag';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export type DragHandleProps = HTMLAttributes<HTMLDivElement> & {
  size?: 'sm' | 'md';
};

export const DragHandle = ({ size = 'md', ...rest }: DragHandleProps) => {
  return (
    <Container data-size={size} {...rest}>
      <IconDrag size={size === 'sm' ? 16 : 24} />
    </Container>
  );
};

const Container = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  cursor: 'grab',
  color: theme.color.buttonIconPositive,
  borderRadius: pxToRem(4),
  outline: 'none',

  '&[data-size="sm"]': {
    width: pxToRem(20),
    height: pxToRem(20),
  },
  '&[data-size="md"]': {
    width: pxToRem(24),
    height: pxToRem(24),
  },

  '&:active': {
    cursor: 'grabbing',
  },

  '&:hover': {
    color: theme.color.buttonIconPositiveHover,
  },

  '&:focus-visible': {
    boxShadow: theme.shadow.focus,
  },
});
